import { render, staticRenderFns } from "./SimpleLayouts.vue?vue&type=template&id=a99d4dba&"
import script from "./SimpleLayouts.vue?vue&type=script&lang=ts&"
export * from "./SimpleLayouts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports